const DOCUMENT_KEYS = {
  "PRIVACY POLICY": "privacy",
  "TERMS & CONDITIONS": "terms",
  DISCLAIMER: "disclaimer",
};

const flushBullets = (blocks, bullets) => {
  if (bullets.length) {
    blocks.push({ type: "list", items: [...bullets] });
    bullets.length = 0;
  }
};

const isHeading = (line) => {
  if (line.includes("@") || line.length > 75) {
    return false;
  }

  if (/[.!?]$/.test(line) && line.length > 40) {
    return false;
  }

  return true;
};

const parseDocument = (title, body) => {
  const lines = body.split("\n");
  const blocks = [];
  const bullets = [];
  let subtitle = "";

  lines.forEach((rawLine) => {
    const line = rawLine.replace(/^[ \t]+/, "").trim();

    if (!line) {
      flushBullets(blocks, bullets);
      return;
    }

    if (line.startsWith("Last updated:")) {
      subtitle = line;
      return;
    }

    if (line.startsWith("●") || line.startsWith("•")) {
      bullets.push(line.replace(/^[●•]\s*/, ""));
      return;
    }

    flushBullets(blocks, bullets);

    if (isHeading(line)) {
      blocks.push({ type: "heading", text: line });
      return;
    }

    blocks.push({ type: "paragraph", text: line });
  });

  flushBullets(blocks, bullets);

  return { title, subtitle, blocks };
};

export const parsePolicies = (text) => {
  const result = {
    privacy: null,
    terms: null,
    disclaimer: null,
  };
  const matches = [...text.matchAll(/^(PRIVACY POLICY|TERMS & CONDITIONS|DISCLAIMER)\s*$/gm)];

  matches.forEach((match, index) => {
    const start = match.index + match[0].length;
    const end = index + 1 < matches.length ? matches[index + 1].index : text.length;
    const key = DOCUMENT_KEYS[match[1]];
    result[key] = parseDocument(match[1], text.slice(start, end).trim());
  });

  return result;
};
